import styled from 'styled-components';
import { Box } from '@blueprism/ui-core';

export const SplitterWrapper = styled(Box)`
  flex: 1 1 auto;
  min-height: 0;
`;
